module.exports = __webpack_public_path__ + "media/images/print-alternate-70b6dee63a2a0956cbe3ac434c295868.svg";